import React from 'react';

import { Col } from 'reactstrap';
import Css from './ListBox.scss';

const listBox = props => {
  const styles = props.styles !== undefined ? props.styles : {};
  const colStyles = props.colStyles !== undefined ? props.colStyles : {};

  return (
    <Col
      md={props.size !== undefined ? props.size : 6}
      onClick={
        props.disabled !== undefined && props.disabled === true
          ? null
          : props.click
      }
      className={Css['list-container']}
      style={colStyles}
    >
      <div
        style={styles}
        className={
          Css['list-box'] +
          ' text-uppercase lakes-bold d-flex align-items-center h-100 ' +
          (props.titleImg !== undefined
            ? Css['list-box-image'] + ' mb-3 '
            : ' ') +
          (props.activeBox === props.id ? Css.active : '') +
          (props.disabled !== undefined && props.disabled === true
            ? ' ' + Css.disabled
            : '')
        }
      >
        {props.title.length > 0 && (
          <div
            className={'w-100 text-center py-4 px-2'}
            dangerouslySetInnerHTML={{ __html: props.title }}
          />
        )}
        {props.titleImg !== undefined && (
          <div
            className={'px-3 py-2 d-flex align-items-center w-100'}
            style={
              props.heightSm !== undefined
                ? { height: '60px' }
                : { height: '80px' }
            }
          >
            <img
              src={props.titleImg.src}
              alt={props.titleImg.alt}
              className={'img-fluid d-block mx-auto grayscale'}
              style={{ maxHeight: '100%' }}
            />
          </div>
        )}
      </div>
    </Col>
  );
};

export default listBox;



// WEBPACK FOOTER //
// ./src/components/ListBox/ListBox.js